import { createEntityAdapter } from '@reduxjs/toolkit';
import { getSensorUniqueKey } from '@utils/sensors/sensors.utils';

import { EquipmentConfiguration } from '@/types/sensor/sensors';

export const equipmentsAdapter = createEntityAdapter<EquipmentConfiguration, string>({
  selectId: getSensorUniqueKey,
  sortComparer: (objectA, objectB) => getSensorUniqueKey(objectA).localeCompare(getSensorUniqueKey(objectB)),
});
